import React from 'react'
import { Skeleton } from 'antd'

const Loading = () => {
  return (
    <div>
      <Skeleton active />
    </div>
  )
}

export default Loading
